import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import GroupOption from './GroupOption';

function Options({ setItemsAnswer, parent, components, itemsAnswer, question }) {
  let trueValue = '';
  if (question?.type !== 'IRA') {
    if (question?.name in itemsAnswer) {
      trueValue = itemsAnswer[question.name];
    }
  } else {
    trueValue = true;
  }
  return (
    trueValue &&
    components.map((component) => (
      <GroupOption
        setItemsAnswer={setItemsAnswer}
        parent={parent}
        question={question}
        key={component?.label}
        component={component}
        itemsAnswer={itemsAnswer}
      />
    ))
  );
}
Options.propTypes = {
  parent: PropTypes.string,
  components: PropTypes.array,
  itemsAnswer: PropTypes.object,
  setItemsAnswer: PropTypes.func,
  question: PropTypes.object,
};
export default Options;
